import { render, staticRenderFns } from "./returnedItems.vue?vue&type=template&id=486dfecc&scoped=true"
import script from "./returnedItems.vue?vue&type=script&lang=js"
export * from "./returnedItems.vue?vue&type=script&lang=js"
import style0 from "./returnedItems.vue?vue&type=style&index=0&id=486dfecc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486dfecc",
  null
  
)

export default component.exports